<template>
  <BaseDropdown
    v-bind="$attrs"
    v-model="selectedOptionId"
    v-on="$listeners"
    :autoScrollOffset="autoScrollOffset"
    :disabled="disabled"
    :styleConfig="styleConfig"
  >
    <template v-slot:expand-symbol-left>
      <slot name="expand-symbol-left" />
    </template>
    <template v-slot:placeholder>
      <slot name="placeholder">
        {{ placeholder }}
      </slot>
    </template>
    <template v-slot:selection>
      <slot name="selection" />
    </template>
    <template v-slot:expand-symbol-right>
      <slot name="expand-symbol-right">
        <GoogleMaterialIconPrimary
          content="expand_more"
          :disabled="disabled"
        />
      </slot>
    </template>
    <template v-slot:dropdown-top>
      <slot name="dropdown-top" />
    </template>
    <template v-slot:select-symbol="props">
      <slot
        name="select-symbol"
        v-bind="props"
      >
        <GoogleMaterialIconPrimary
          content="check"
          v-if="props.selected"
          :disabled="disabled"
        />
      </slot>
    </template>
    <template v-slot:option="props">
      <slot
        name="option"
        v-bind="props.option"
      />
    </template>
    <template v-slot:action-symbol="props">
      <slot
        name="action-symbol"
        v-bind="props"
      />
    </template>
    <template v-slot:dropdown-bottom>
      <slot name="dropdown-bottom" />
    </template>
  </BaseDropdown>
</template>

<script>
  import BaseDropdown from '@base/v2/base-dropdown'
  import GoogleMaterialIconPrimary from '@modules/v2/icon/google-material-icon-primary'
  import { FontStyle, Layout } from '@js/styles'
  import { mapGetters } from 'vuex'

  export default {
    name: 'DropdownPrimary',
    inheritAttrs: false,
    model: {
      prop: 'vmodelValue',
      event: 'change',
    },
    components: {
      BaseDropdown,
      GoogleMaterialIconPrimary,
    },
    props: {
      vmodelValue: {
        type: [Number, Object, String],
        required: false,
        default: null
      },
      autoScrollOffset: {
        type: [Number, String],
        required: false,
        default: -8
      },
      disabled: {
        type: Boolean,
        required: false,
        default: false
      },
      maxHeightDropdownList: {
        type: String,
        required: false,
        default: '320px'
      },
      placeholder: {
        type: String,
        required: false,
        default: 'Select'
      },
    },
    data: function () {
      return {
        selectedOptionId: this.vmodelValue,
        styleConfig: {
          actionSymbol: {},
          dropdown: {
            boxShadow: '0 4px 16px rgba(0, 0, 0, 0.2)',
          },
          dropdownList: {
            maxHeight: this.maxHeightDropdownList,
          },
          expandSymbol: {},
          option: {
            alignItems: 'center',
            display: 'flex',
            height: '100%',
            overflow: 'flex',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
          },
          placeholder: {},
          row: {
            cursor: {
              '': 'pointer',
              disabled: 'default',
            },
            height: '32px',
            padding: `0 ${Layout.space.sm} 0 0`,
          },
          selectionContainer: {
            alignItems: 'center',
            borderRadius: Layout.space.xs,
            cursor: {
              '': 'pointer',
              disabled: 'default',
            },
            display: 'flex',
            height: '32px',
            padding: `0 12px 0 ${Layout.space.md}`,
          },
          selection: {
            fontFamily: FontStyle.family.primary,
            fontSize: FontStyle.size.md,
            fontWeight: FontStyle.weight.md,
          },
          selectSymbol: {
            alignItems: 'center',
            display: 'flex',
            height: '100%',
            justifyContent: 'center',
            minWidth: Layout.space.lg,
            width: Layout.space.lg,
          },
        },
      };
    },
    created: function () {
      Object.assign(
        this.styleConfig.dropdown,
        {
          backgroundColor: {
            '': this.color.shadow1(),
          },
        },
      );
      Object.assign(
        this.styleConfig.placeholder,
        {
          color: this.color.dark4(),
        },
      );
      Object.assign(
        this.styleConfig.row,
        {
          backgroundColor: {
            '': this.color.shadow1(),
            hover: this.color.dark6(),
            active: this.color.dark6(),
            disabled: this.color.dark4(),
            selected: this.color.dark5(),
            'selected-hover': this.color.dark6(),
          },
          fontWeight: {
            '': FontStyle.weight.md,
            selected: FontStyle.weight.lg,
            'selected-hover': FontStyle.weight.lg,
          },
        },
      );
      Object.assign(
        this.styleConfig.selectionContainer,
        {
          backgroundColor: this.color.shadow1(),
          border: {
            '': `solid ${this.color.dark4()}`,
            disabled: `solid ${this.color.dark4()}`,
            hover: `solid ${this.color.dark2()}`,
            show: `solid ${this.color.action1()}`,
          },
          borderWidth: {
            '': '1px',
            disabled: 'none',
          },
        },
      );
      Object.assign(
        this.styleConfig.selection,
        {
          color: {
            '': this.color.dark3(),
            disabled: this.color.dark4(),
          },
        },
      );
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
    },
    watch: {
      vmodelValue: function (newVal, oldVal) {
        this.selectedOptionId = newVal;
      },
    },
  };
</script>
